import { Card } from "antd";
import { observer } from "mobx-react";
import * as React from "react";

import { ZuluIcon } from "src/app/shared/icon";

interface Props {
	title: React.ReactNode;
	extra?: React.ReactNode;
	actions?: React.ReactNode[];
	initialCollapseState?: boolean;
	keyTitle?:string
	onToggleCollapse?: (collapsed: boolean, key?:string) => void;
}

interface State {
	collapsed: boolean;
}

@observer
export class CollapseCard extends React.Component<Props, State> {
	public state: State = { collapsed: this.props.initialCollapseState || false };

	public render() {
		const { actions, children, extra, title } = this.props;
		const { collapsed } = this.state;

		const header = (
			<React.Fragment>
				<ZuluIcon
					type={collapsed ? 'right' : 'down'}
					onClick={this.toggleCollapse}
					style={{ cursor: 'pointer' }}
					className="mr-3"
				/>
				{title}
			</React.Fragment>
		);

		return (
			<Card
				title={header}
				extra={extra}
				actions={actions}
				className="no-body-card"
			>
				{!collapsed && children}
			</Card>
		);
	}

	private toggleCollapse = () => {
		const { onToggleCollapse, keyTitle } = this.props;

		this.setState({
			collapsed: !this.state.collapsed
		}, () => onToggleCollapse ? onToggleCollapse(!this.state.collapsed, keyTitle) : undefined);
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/collapse-card.view.tsx